import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./navBar.css";
import MhomeLogo from "../image/MhomeLogo.png";

function NavBar() {
  const { i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuRef = useRef(null);
  const burgerRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        burgerRef.current &&
        !menuRef.current.contains(event.target) &&
        !burgerRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img src={MhomeLogo} alt="Logo" />
        </Link>
      </div>

      <div
        ref={burgerRef}
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div
        className={`backdrop ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      <ul ref={menuRef} className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            {i18n.t("nav_home")}
          </Link>
        </li>
        <li>
          <Link to="/about" onClick={() => setMenuOpen(false)}>
            {i18n.t("nav_about")}
          </Link>
        </li>
        <li>
          <Link to="/our-work" onClick={() => setMenuOpen(false)}>
            {i18n.t("nav_work")}
          </Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            {i18n.t("nav_contact")}
          </Link>
        </li>

        <li className="mobile-lang">
          <button
            className={i18n.language === "en" ? "active" : ""}
            onClick={() => changeLanguage("en")}
          >
            EN
          </button>
          <button
            className={i18n.language === "sq" ? "active" : ""}
            onClick={() => changeLanguage("sq")}
          >
            SQ
          </button>
        </li>
      </ul>

      <div className="desktop-lang">
        <button
          className={i18n.language === "en" ? "active" : ""}
          onClick={() => changeLanguage("en")}
        >
          EN
        </button>
        <button
          className={i18n.language === "sq" ? "active" : ""}
          onClick={() => changeLanguage("sq")}
        >
          SQ
        </button>
      </div>
    </nav>
  );
}

export default NavBar;
